import styles from './IconButton.module.css';

interface IconButtonProps {
  icon: React.ReactNode;
  title?: string;
  onClick?: () => void;
  color?: 'default' | 'danger';
}

export function IconButton({
  icon,
  title,
  onClick,
  color = 'default',
}: IconButtonProps) {
  return (
    <button
      className={`${styles.iconButton} ${
        color === 'danger' ? styles.danger : ''
      }`}
      title={title}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      {icon}
    </button>
  );
}